import Vue from "vue"
import Vuex from "vuex"
import getSystemInfo from "../utils/getSystemIno"

import toast from "./module/toast"
import loading from "./module/loading"
import userInfo from "./module/userInfo"
import contribute from "./module/contribute"
import home from "./module/home"
import workDetail from "./module/workDetail"
import myWork from "./module/myWork"
import activityInfo from "./module/activityInfo"
import slideVerify from "./module/slideVerify"
import workCollection from "./module/workCollection"
import messagePopup from "./module/messagePopup"
import cert from "./module/cert"
import loginByPhonePopup from "./module/loginByPhonePopup"
import myContribute from "./module/myContribute"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    toast,
    loading,
    userInfo,
    contribute,
    home,
    workDetail,
    myWork,
    activityInfo,
    slideVerify,
    workCollection,
    messagePopup,
    cert,
    loginByPhonePopup,
    myContribute
  },
  state: {
    systemInfo: {
      ios: false,
      pc: false,
      android: false,
      isWx: false,
      isPhoneX: false,
      isNfPlus: false
    },
    openAppOptions: {
      show: false,
      tips: "",
      closeCallback: null
    }
  },
  getters: {
    systemInfo: state => state.systemInfo,
    openAppOptions: state => state.openAppOptions
  },
  mutations: {
    setSystemInfo(state, systemInfo) {
      state.systemInfo = systemInfo
    },
    showOpenApp(state, tips) {
      if (typeof tips === "string") {
        state.openAppOptions.tips = tips
        state.openAppOptions.closeCallback = null
      }
      if (typeof tips === "object") {
        Object.assign(state.openAppOptions, { closeCallback: null }, tips)
      }
      state.openAppOptions.show = true
    },
    closeOpenApp(state) {
      state.openAppOptions.closeCallback && state.openAppOptions.closeCallback()
      state.openAppOptions.show = false
    }
  },
  actions: {
    async getSystemInfo({ commit }) {
      const systemInfo = await getSystemInfo()
      commit("setSystemInfo", systemInfo)
    }
  }
})
